import { useInstantSearch } from "react-instantsearch";
import { useCachedInfiniteHits } from "./useCachedInfiniteHits";

/**
 * useInfiniteProducts
 *
 * **Why this hook?**
 * - Separates data fetching logic from UI.
 * - Ensures pagination tracking includes cached pages.
 *
 * **What does it do?**
 * - Fetches products from Algolia InstantSearch.
 * - Tracks the total number of pages loaded from cache.
 * - Returns product items and loading state.
 *
 * @returns {Object} { items, isLoadingMore, totalPagesLoaded }
 * - `items` - The list of fetched product results.
 * - `isLoadingMore` - A boolean indicating whether new products are being loaded.
 * - `totalPagesLoaded` - The highest page loaded, including cached pages.
 */
export function useInfiniteProducts({ hitsPerPage }: { hitsPerPage?: number }) {
  const { status } = useInstantSearch();
  const { items } = useCachedInfiniteHits();

  // useEffect(() => {
  //   if (typeof showPrevious === 'function') {
  //     showPrevious();
  //   }
  // }, [showPrevious]);

  // const totalPages = hitsPerPage > 0 ? Math.ceil((items?.length || 0) / hitsPerPage) : 1;
  // BIG FYI: connnectStats has information that might be helpful: node_modules/react-instantsearch/node_modules/instantsearch.js/es/connectors/stats/connectStats.d.ts
  // -- -- ie. nbPages

  // useEffect(() => {
  //   if (totalPages > 1) {
  //     console.log("useInfiniteProducts.totalPages.totalPages > 1");
  //     updateQueryParamInBrowser("page", String(totalPages)); 
  //   }
  // }, [])

  const isLoadingMore = status === "stalled" || status === "loading";

  return { items: items, isLoadingMore };
}
